import './telephone-strip/cssV.styl';
import { defineComponent } from 'vue';
// import phoneDemo from './components/phoneDemo.vue'
import telephoneStrip from './telephone-strip/index.vue';
import './assets/iconfont/iconfont.css';
import './styles/element/index.scss';
import './telephone-strip/cssV.styl';
export default defineComponent({
  name: 'App',
  components: {
    // phoneDemo,
    telephoneStrip
  }
});